import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { CheckIcon } from "@heroicons/react/24/outline";
import * as Select from "@radix-ui/react-select";

interface Props {
  min: number;
  max: number;
}
const NumberDropdownContent = ({ max, min }: Props) => {
  return (
    <Select.Content className="relative z-50 overflow-hidden bg-white border border-gray-300 rounded-md shadow-sm">
      <Select.ScrollUpButton className="flex items-center justify-center h-6 text-black cursor-default">
        <ChevronUpIcon className="w-5 h-5" />
      </Select.ScrollUpButton>
      <Select.Viewport className="p-1.5">
        {Array.from({ length: max - min + 1 }, (_, index) => index + min).map(
          (value) => (
            <Select.Item
              key={value}
              value={value.toString()}
              className="relative flex items-center h-6 pl-6 text-sm leading-none text-black rounded select-none pr-9 focus:outline-none focus:bg-indigo-500 focus:text-indigo-50"
            >
              <Select.ItemText>{value}</Select.ItemText>
              <Select.ItemIndicator className="absolute left-0 w-6 cursor-default">
                <CheckIcon className="w-4 h-4" />
              </Select.ItemIndicator>
            </Select.Item>
          )
        )}
      </Select.Viewport>
      <Select.ScrollDownButton className="flex items-center justify-center h-6 text-black cursor-default">
        <ChevronDownIcon className="w-5 h-5" />
      </Select.ScrollDownButton>
    </Select.Content>
  );
};

export default NumberDropdownContent;
